import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, Typography, Box, Grid, Divider } from '../../../../../components/mui/Core/index'

function InfoRow({ label, value, valueColor }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.5 }}>
      <Typography sx={{ fontSize: '0.78rem', fontFamily: 'AtlasGroteskRegular', color: '#606060' }}>
        {label}
      </Typography>
      <Typography
        sx={{ fontSize: '0.85rem', fontFamily: 'AtlasGroteskRegular', color: valueColor || '#000000', fontWeight: valueColor ? 600 : 400 }}
      >
        {value ?? '—'}
      </Typography>
    </Box>
  )
}
InfoRow.propTypes = { label: PropTypes.string.isRequired, value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), valueColor: PropTypes.string }

const fmt = (n) => n != null ? `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2 })}` : '—'

function OrderInfoCard({ orderDetail }) {
  if (!orderDetail) return null
  const creditColor = orderDetail.availableCredit < 0 ? '#cc3f0c' : '#2a7b5a'
  return (
    <Grid container spacing={2}>
      {/* Billing & Shipping */}
      <Grid size={{ xs: 12, md: 5 }}>
        <Card sx={{ height: '100%' }}>
          <CardContent>
            <Typography sx={{ fontFamily: 'SanomatMedium', fontSize: '0.9rem', color: '#145a4b', mb: 1 }}>
              Order Info
            </Typography>
            <Divider sx={{ mb: 1.5 }} />
            <InfoRow label='Bill To' value={orderDetail.billTo} />
            <InfoRow label='Ship To' value={orderDetail.shipTo} />
            <InfoRow label='PO Number' value={orderDetail.poNumber} />
            <InfoRow label='Payment Terms' value={orderDetail.paymentTerms} />
            <InfoRow label='Warehouse' value={orderDetail.warehouseCode} />
            <InfoRow
              label='Created'
              value={orderDetail.createdAt ? new Date(orderDetail.createdAt).toLocaleDateString('en-US') : '—'}
            />
          </CardContent>
        </Card>
      </Grid>
      {/* Credit */}
      <Grid size={{ xs: 12, md: 4 }}>
        <Card sx={{ height: '100%' }}>
          <CardContent>
            <Typography sx={{ fontFamily: 'SanomatMedium', fontSize: '0.9rem', color: '#145a4b', mb: 1 }}>
              Credit Overview
            </Typography>
            <Divider sx={{ mb: 1.5 }} />
            <InfoRow label='Credit Limit' value={fmt(orderDetail.creditLimit)} />
            <InfoRow label='AR Outstanding' value={fmt(orderDetail.arOutstanding)} />
            <InfoRow label='Order Value' value={fmt(orderDetail.orderValue)} />
            <InfoRow
              label='Available Credit'
              value={fmt(orderDetail.availableCredit)}
              valueColor={creditColor}
            />
          </CardContent>
        </Card>
      </Grid>
      {/* Allocation status */}
      <Grid size={{ xs: 12, md: 3 }}>
        <Card sx={{ height: '100%' }}>
          <CardContent>
            <Typography sx={{ fontFamily: 'SanomatMedium', fontSize: '0.9rem', color: '#145a4b', mb: 1 }}>
              Status
            </Typography>
            <Divider sx={{ mb: 1.5 }} />
            <InfoRow label='Order Status' value={orderDetail.orderStatus?.replace(/_/g, ' ')} />
            <InfoRow label='Allocation' value={orderDetail.allocationStatus?.replace(/_/g, ' ')} />
            <InfoRow label='Client Code' value={orderDetail.clientCode} />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

OrderInfoCard.propTypes = {
  orderDetail: PropTypes.object,
}

export default OrderInfoCard
